import { ReactNode } from 'react';
import { Options } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES, Node } from '@contentful/rich-text-types';

import { ExternalLink } from '../../../../../components/Clickables/ExternalLink/ExternalLink';
import { Text } from '../../../../../components/Text/Text';

export const faqRichTextOptions: Options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_: Node, children: ReactNode) => (
      <Text variant="sm" className="mb-0">
        {children}
      </Text>
    ),
    [BLOCKS.UL_LIST]: (_: Node, children: ReactNode) => (
      <ul className="m-0 list-disc px-4 py-2">{children}</ul>
    ),
    [BLOCKS.OL_LIST]: (_: Node, children: ReactNode) => (
      <ol className="m-0 list-decimal px-4 py-2">{children}</ol>
    ),
    [BLOCKS.LIST_ITEM]: (_: Node, children: ReactNode) => (
      <li className="body-text-sm m-0">{children}</li>
    ),
    [INLINES.HYPERLINK]: (node: Node, children: ReactNode) => (
      <ExternalLink href={`${node.data.uri}`} className="body-text-sm text-primary" target="_blank">
        {children}
      </ExternalLink>
    ),
  },
};
